import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NEVER, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ENV_CONFIG, EnvironmentConfig } from '@core/environment-config.interface';
import { Inject } from '@angular/core';
import { AlertService } from '@core/services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalcloseService } from '@core/services/modalclose.service';
import { MaintenanceService } from '@core/services/maintenance.service';

export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    @Inject(ENV_CONFIG) private config: EnvironmentConfig,
    private maintenanceService: MaintenanceService,
    private alertService: AlertService,
    private translateService: TranslateService,
    //private modalCloseService: ModalcloseService,
    ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        // retry(1),
        catchError((error: HttpErrorResponse) => this.handleError(error))
      );
  }

  handleError(error: HttpErrorResponse): Observable<never> {

    if (error.status === 400) {
        throw error
      //return NEVER;
    }

    if (error.status === 401) {
      document.location.href = this.config.loginUrl;
    }

    if (error.status === 409) {
      document.location.href = this.config.logoutUrl;
    }

    if (error.status === 410) {
      this.maintenanceService.setMaintenanceMode(error.message);
      return NEVER;
    }

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      //errorMessage = `Error: ${error.error.message}`;
      errorMessage = this.translateService.instant('error.service-call-fail');
    } else {
      // server-side error
      const serviceName = error.url.startsWith(this.config.serviceUrlPrefix) ?
        error.url.slice(this.config.serviceUrlPrefix.length) : '';
      errorMessage = this.translateService.instant('error.service-call-fail', {service: serviceName});
    }

    //this.modalCloseService.closePrefferedAgentModal();
    const options = {
      autoClose: true
    };

    this.alertService.error(errorMessage, options);
    //return throwError(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
